import Navigation from "./navigations/Navigation";
import { AuthProvider } from "./contexts/AuthContext";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <AuthProvider>
        <Navigation />
      </AuthProvider>
    </LocalizationProvider>
  );
}

export default App;
